var React = require('react');

function SearchWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_5424","data-name":"Group 5424","transform":"translate(-1112 -340)"},[React.createElement("g",{"id":"Ellipse_18","data-name":"Ellipse 18","transform":"translate(1112 340)","fill":"none","stroke":"#ffffff","strokeWidth":"2","key":0},[React.createElement("circle",{"cx":"16.5","cy":"16.5","r":"16.5","stroke":"none","key":0}),React.createElement("circle",{"cx":"16.5","cy":"16.5","r":"15.5","fill":"none","key":1})]),React.createElement("line",{"id":"Line_446","data-name":"Line 446","x2":"12.943","y2":"12.943","transform":"translate(1138.194 369.276)","fill":"none","stroke":"#ffffff","strokeWidth":"2","key":1})]));
}

SearchWhite.defaultProps = {"width":"28.844","height":"30.926","viewBox":"0 0 39.844 42.926"};

module.exports = SearchWhite;

SearchWhite.default = SearchWhite;
